var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import { normalizeKey } from "@bookingcom/bui-core/utilities/helpers";
import Keys from "@bookingcom/bui-core/constants/keys";
import styles from "@bookingcom/bui-core/css/Actionable.module.css";
var Actionable = function (props, ref) {
    var children = props.children, className = props.className, insetFocus = props.insetFocus, attributes = props.attributes, tagName = props.tagName, preventDefault = props.preventDefault, onClick = props.onClick, mixin = props.mixin;
    var rootClassNames = classNames(styles.root, className, insetFocus && styles["focus-inset"], mixinClassNames(mixin));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    var href = props.href || (attributes === null || attributes === void 0 ? void 0 : attributes.href);
    var type = props.type || (attributes === null || attributes === void 0 ? void 0 : attributes.type);
    var disabled = props.disabled || (attributes === null || attributes === void 0 ? void 0 : attributes.disabled);
    var clickHandler = onClick || (attributes === null || attributes === void 0 ? void 0 : attributes.onClick);
    var hasFocusHandler = (attributes === null || attributes === void 0 ? void 0 : attributes.onFocus) || (attributes === null || attributes === void 0 ? void 0 : attributes.onBlur);
    var isLink = Boolean(href || (attributes === null || attributes === void 0 ? void 0 : attributes.href));
    var isButton = Boolean(clickHandler || hasFocusHandler || type);
    var TagName;
    if (isLink) {
        rootAttributes.href = href;
        TagName = "a";
    }
    else if (isButton && (!tagName || tagName === "button")) {
        TagName = "button";
        rootAttributes.type = type || "button";
    }
    else if (isButton) {
        var isFocusable = tagName === "label";
        var simulateButton = !isFocusable || clickHandler || hasFocusHandler;
        TagName = tagName || "span";
        rootAttributes.role = simulateButton ? "button" : undefined;
        rootAttributes.tabIndex = simulateButton ? 0 : undefined;
    }
    else {
        TagName = tagName || "span";
    }
    var handleClick = function (event) {
        if (preventDefault)
            event.preventDefault();
        if (onClick && !disabled)
            onClick(event);
        if ((attributes === null || attributes === void 0 ? void 0 : attributes.onClick) && !disabled)
            (attributes === null || attributes === void 0 ? void 0 : attributes.onClick)(event);
    };
    var handleKeyDown = function (event) {
        var simulatingButton = rootAttributes.role === "button";
        if (!simulatingButton || isLink)
            return;
        var key = normalizeKey(event.key);
        if (key !== Keys.SPACE && key !== Keys.ENTER)
            return;
        event.preventDefault();
        handleClick(event);
    };
    return (React.createElement(TagName, __assign({ ref: ref }, rootAttributes, { disabled: disabled, className: rootClassNames, onClick: handleClick, onKeyDown: handleKeyDown }), children));
};
export default React.forwardRef(Actionable);
